module.exports = __webpack_public_path__ + "img/logo.e3d93386.svg";